import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Input } from 'antd';
import { errorProps } from './props';

const CustomInput = React.forwardRef(({ className, ...rest }, ref) =>
  <>
    <Input className={className} {...rest} ref={ref} />
  </>,
);

CustomInput.propTypes = {
  className: PropTypes.string,
};

export default styled(CustomInput)`
  color: ${p => p.theme.colors.text} !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  ${errorProps};
`;
